import { CarouselImage } from '../types';

/**
 * Imágenes del carrusel del hero (columna derecha de la landing pública).
 *
 * Son las piezas de la campaña de Meta (flujo + video) de Conectemos Chile.
 * Para rotar la campaña: reemplazar los `.webp` en `public/assets/img/hero/`
 * (nombrados `campana-{mes}-{pieza}.webp`) y editar este array — `alt` debe
 * describir el contenido real de la pieza (precio incluido cuando el arte lo
 * muestra), nunca un texto genérico.
 *
 * Campaña noviembre 2026 (subida 2026-10-29). Optimizadas con
 * `cwebp -q 80 -m 6 -sharp_yuv -resize 900 0` (4:5) / `-resize 720 0` (9:16).
 * Precios verificados contra src/lib/utils/pricing.ts y docs/PRECIOS.md:
 * domicilio $75.000 (PRECIO_DOMICILIO), pareja 50' $38.750 / 90' $46.000,
 * sexología $36.000 (fijo, M12). Planes mensuales $124.000 (4×50' −20%) y
 * $147.200 (4×90' −20%) son landing-only: no los cobra el sistema, se
 * coordinan a mano. Si un precio cambia, hay que rehacer el arte.
 *
 * Fuera a propósito: pieza "Terapia de parejas online $38.750 · 90 minutos"
 * — el sistema cobra $46.000 por pareja 90' online. No se publica hasta
 * corregir el arte (o crear la promo en create_consultation).
 *
 * Encuadre mixto 4:5 + 9:16 dentro de un marco 4:5 con `object-fit: contain`
 * (ver `.hero-promo-carousel` en Hero.css): son flyers con texto, un `cover`
 * recortaría precios y titulares.
 */
export const heroCarouselImages: CarouselImage[] = [
  {
    src: '/assets/img/hero/campana-nov-pareja-domicilio.webp',
    alt: 'Terapia de parejas a domicilio por $75.000, boletas reembolsables con Isapres y seguros complementarios, lunes y martes de 9:00 a 20:00, cobertura en todo Santiago',
  },
  {
    src: '/assets/img/hero/campana-nov-pareja-sexologia-precios.webp',
    alt: 'Programa de terapia de pareja y sexología: 50 minutos $38.750, 90 minutos $46.000, plan mensual $147.200 con ahorro de hasta 20%. Bombero Adolfo Ossa 1010, Santiago',
  },
  {
    src: '/assets/img/hero/campana-nov-pareja-plan-mensual.webp',
    alt: 'Terapia de parejas, plan mensual $124.000, ahorra un 20%. Mejora la comunicación, resuelve conflictos, fortalece la intimidad',
  },
  {
    src: '/assets/img/hero/campana-nov-sexologia-clinica.webp',
    alt: 'Programa de sexología clínica de 8 sesiones, valor por sesión $36.000, boletas reembolsables con Isapres y seguros complementarios',
  },
];
